import cl from 'classnames';
import * as React from 'react';
import { Editor } from 'slate';
import { useSlate } from 'slate-react';
import styled from 'styled-components';

import { setDefaults } from '../../../../../slatePlugins/common/utils/setDefaults';
import { ToolbarButtonProps } from '../../../../../slatePlugins/components/ToolbarButton/ToolbarButton.types';
import { colorsV2 } from '../../../../colors-v2';
import { isMarkActive } from '../../../../Editor/utils';
import ColorSelector from '../../../elements/highlight/toolbar/ColorSelector';
import DropdownToolbar from '../../../toolbars/DropdownToolbar';
import { DefaultBalloonToolbar } from '../../../toolbars/ToolbarWrapper';
import { DEFAULT_UNDERLINE_COLOR } from '../defaults';
import { UnderlineColorMarkPluginOptions } from '../types';

const useCurrentUnderlineColorKey = (type) => {
  const editor = useSlate();
  const marks = Editor.marks(editor);
  if (marks && marks[type]) {
    return marks[type].colorKey;
  }
  return null;
};

const UnderlineColorMenu = ({ colors, options, setVisibleMenu }) => {
  const editor = useSlate();
  const {
    underlineColor: { type },
  } = options;
  const currentColorKey = useCurrentUnderlineColorKey(type);

  return (
    <ColorSelector
      colors={colors}
      currentColor={currentColorKey}
      showDeselectColor
      onDeselectColor={() => {
        Editor.removeMark(editor, type);
        setVisibleMenu(false);
      }}
      onSelectColor={(color) => {
        Editor.addMark(editor, type, { colorKey: color.key });
        setVisibleMenu(false);
      }}
    />
  );
};

const ColorMark = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 28px;
  height: 24px;
  user-select: none;
  cursor: pointer;
  vertical-align: middle;

  > svg {
    display: block;
    width: 20px;
    height: 20px;
  }
  &.active {
    background-color: ${colorsV2.primary10};
    border-radius: 6px;
    svg {
      color: ${colorsV2.primary100};
    }
  }
`;

const ToolbarUnderlineColorMarkBase = ({
  textColor,
  colors,
  className,
  styles,
  icon,
}: Partial<ToolbarButtonProps> & UnderlineColorMarkPluginOptions) => {
  const options = setDefaults({ textColor }, DEFAULT_UNDERLINE_COLOR);
  const editor = useSlate();
  const isActive = isMarkActive(editor as any, options.underlineColor.type);
  const [isVisible, setVisible] = React.useState(false);

  return (
    <DropdownToolbar
      visible={isVisible}
      overlay={
        <DefaultBalloonToolbar hidden={false} icon={icon}>
          <UnderlineColorMenu colors={colors} options={options} setVisibleMenu={setVisible} />
        </DefaultBalloonToolbar>
      }
      placement="topLeft"
      onVisibleChange={setVisible}
    >
      <ColorMark
        className={cl(className, { active: isActive, 'slate-ToolbarButton-active': isActive })}
      >
        {icon}
      </ColorMark>
    </DropdownToolbar>
  );
};

export const ToolbarUnderlineColorMark = ToolbarUnderlineColorMarkBase;
